// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"4e457cb2","92":"fb1fabe4","149":"8c3b2286","162":"7d5b3c6a","292":"07f2d2dc","432":"3ba6d723","456":"45c2174c","484":"823fd112","573":"38018fb3","579":"476ce5a6","624":"cf4c0441","655":"f2683d4d","944":"3c502f46"}[chunkId] + ".chunk.js";
};